import type {
  QueryClient,
  QueryFunctionContext,
  UseQueryOptions,
  UseSuspenseQueryOptions,
} from "@tanstack/react-query"
import type { Params } from "react-router"

import { getModel, getRelatedModels } from "@/api"
import type { ModelType, RelatedModelType } from "@/types/api/published"

export const modelQuery = (model_nr?: string): UseQueryOptions<ModelType> => ({
  queryKey: ["model", model_nr],
  queryFn: ({ signal }: QueryFunctionContext) => getModel(signal, model_nr),
  throwOnError: true,
})
export const modelSuspenseQuery = (model_nr?: string): UseSuspenseQueryOptions<ModelType> => ({
  queryKey: ["model", model_nr],
  queryFn: ({ signal }: QueryFunctionContext) => getModel(signal, model_nr),
})

export const loader =
  (queryClient: QueryClient) =>
  async ({ params }: { params: Params<string> }) => {
    if (params.modelid === undefined) {
      return
    }
    const query = modelQuery(params.modelid)
    return { promise: queryClient.prefetchQuery(query) }
  }

export const relatedModelsQuery = (model_nr?: string): UseQueryOptions<RelatedModelType[]> => ({
  queryKey: ["relatedModels", model_nr],
  queryFn: ({ signal }: QueryFunctionContext) => getRelatedModels(signal, model_nr),
})
